"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var dateFormat = require("dateformat");
var uuidv4 = require("uuid/v4");
var AnalyticsEventFactory = /** @class */ (function () {
    function AnalyticsEventFactory(serviceName, pod, hostName) {
        this.serviceName = serviceName;
        this.pod = pod;
        this.hostName = hostName;
    }
    AnalyticsEventFactory.prototype.createEvent = function () {
        return new AnalyticsEventBuilder(this.serviceName, this.pod, this.hostName);
    };
    AnalyticsEventFactory.prototype.createEventFromProps = function (eventType, props) {
        if (props === void 0) { props = {}; }
        var builder = this.createEvent().ofType(eventType);
        for (var prop in props) {
            var val = props[prop];
            if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") {
                builder = builder.withProperty(prop, val);
            }
        }
        return builder.build();
    };
    return AnalyticsEventFactory;
}());
exports.AnalyticsEventFactory = AnalyticsEventFactory;
var AnalyticsEventBuilder = /** @class */ (function () {
    function AnalyticsEventBuilder(serviceName, pod, hostName) {
        this.event = {
            guid: uuidv4(),
            host_name: hostName,
            host_timestamp: dateFormat(new Date(), 'yyyy-mm-dd hh:MM:ss,l o'),
            pod: pod,
            properties: {},
            service_name: serviceName,
            type: 'AnalyticsEvent',
        };
    }
    AnalyticsEventBuilder.prototype.ofType = function (type) {
        this.event.type = type;
        return this;
    };
    AnalyticsEventBuilder.prototype.withProperty = function (name, value) {
        this.event.properties[name] = value;
        return this;
    };
    AnalyticsEventBuilder.prototype.build = function () {
        return this.event;
    };
    return AnalyticsEventBuilder;
}());
exports.AnalyticsEventBuilder = AnalyticsEventBuilder;
//# sourceMappingURL=AnalyticsEvents.js.map